<div
  *ngIf="notify.toast$ | async as toast"
  (mouseenter)="notify.pause()"
  (mouseleave)="notify.resume()"
  class="toast align-items-center bg-{{ toast.type }} show slide-in" 
  role="alert"
  aria-live="assertive"
  aria-atomic="true"
  (click)="notify.close()"
>
  <div class="d-flex justify-content-between">
    <div class="toast-body text-white fs-5">
      {{ toast.text }}
    </div>
    <!-- <button
      type="button"
      class="bg-transparent text-white border-0 pe-3 fs-5"
      (click)="notify.close()"
    >
      X
    </button> -->
  </div>
</div>
